var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTenantManagement(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.62718 3C8.03745 3 7.55938 3.4683 7.55938 4.04598V6.73563C7.55938 7.31331 8.03745 7.78161 8.62718 7.78161H9.38989V8.52874H3.89836C3.30864 8.52874 2.83057 8.99704 2.83057 9.57471V10.7701H4.05091V9.72414H9.38989V10.7701H10.6102V9.72414H16.0255V10.7701H17.2459V9.57471C17.2459 8.99704 16.7678 8.52874 16.1781 8.52874H10.6102V7.78161H11.373C11.9627 7.78161 12.4408 7.31331 12.4408 6.73563V4.04598C12.4408 3.4683 11.9627 3 11.373 3H8.62718ZM8.77972 4.1954V6.58621H11.2204V4.1954H8.77972Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1 12.2644C1 11.6867 1.47807 11.2184 2.0678 11.2184H4.81356C5.40329 11.2184 5.88136 11.6867 5.88136 12.2644V14.954C5.88136 15.5317 5.40329 16 4.81356 16H2.0678C1.47807 16 1 15.5317 1 14.954V12.2644ZM2.22034 14.8046V12.4138H4.66102V14.8046H2.22034Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.55933 12.2644C7.55933 11.6867 8.0374 11.2184 8.62713 11.2184H11.3729C11.9626 11.2184 12.4407 11.6867 12.4407 12.2644V14.954C12.4407 15.5317 11.9626 16 11.3729 16H8.62713C8.0374 16 7.55933 15.5317 7.55933 14.954V12.2644ZM8.77967 14.8046V12.4138H11.2203V14.8046H8.77967Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.1187 12.2644C14.1187 11.6867 14.5968 11.2184 15.1865 11.2184H17.9323C18.522 11.2184 19.0001 11.6867 19.0001 12.2644V14.954C19.0001 15.5317 18.522 16 17.9323 16H15.1865C14.5968 16 14.1187 15.5317 14.1187 14.954V12.2644ZM15.3391 14.8046V12.4138H17.7798V14.8046H15.3391Z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTenantManagement);
export default __webpack_public_path__ + "static/media/tenant-management.svg";
export { ForwardRef as ReactComponent };